export default `:host {
  display: grid;
  grid-column: span 1;
  width: 100%;
  box-sizing: border-box;
}

:host([hidden]) {
  display: none;
}

:host([enable-container]) {
  container-type: inline-size;
}

.ids-form-layout-group-content {
  display: grid;
  grid-template-columns: subgrid;
  gap: inherit;
  width: 100%;
  align-items: start;
}

:host([auto-fit]) .ids-form-layout-group-content {
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}

:host([cols]) .ids-form-layout-group-content {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

:host([cols="1"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

:host([cols="2"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

:host([cols="3"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

:host([cols="4"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

:host([cols="5"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

:host([cols="6"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

:host([cols="7"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

:host([cols="8"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

:host([cols="9"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

:host([cols="10"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}

:host([cols="11"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(11, minmax(0, 1fr));
}

:host([cols="12"]) .ids-form-layout-group-content {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

@media (width >= 0) {
  :host([cols-xs="1"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xs="2"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xs="3"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xs="4"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xs="5"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xs="6"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xs="7"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xs="8"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xs="9"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xs="10"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xs="11"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xs="12"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media (width >= 767px) {
  :host([cols-sm="1"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-sm="2"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-sm="3"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-sm="4"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-sm="5"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-sm="6"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-sm="7"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-sm="8"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-sm="9"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-sm="10"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-sm="11"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-sm="12"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media (width >= 927px) {
  :host([cols-md="1"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-md="2"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-md="3"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-md="4"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-md="5"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-md="6"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-md="7"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-md="8"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-md="9"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-md="10"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-md="11"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-md="12"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media (width >= 928px) {
  :host([cols-lg="1"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-lg="2"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-lg="3"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-lg="4"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-lg="5"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-lg="6"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-lg="7"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-lg="8"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-lg="9"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-lg="10"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-lg="11"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-lg="12"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media (width >= 1183px) {
  :host([cols-xl="1"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xl="2"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xl="3"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xl="4"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xl="5"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xl="6"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xl="7"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xl="8"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xl="9"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xl="10"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xl="11"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xl="12"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media (width >= 2463px) {
  :host([cols-xxl="1"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xxl="2"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xxl="3"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xxl="4"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xxl="5"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xxl="6"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xxl="7"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xxl="8"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xxl="9"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xxl="10"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xxl="11"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xxl="12"]:not([enable-container])) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 0) {
  :host([cols-xs="1"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xs="2"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xs="3"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xs="4"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xs="5"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xs="6"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xs="7"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xs="8"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xs="9"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xs="10"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xs="11"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xs="12"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 767px) {
  :host([cols-sm="1"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-sm="2"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-sm="3"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-sm="4"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-sm="5"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-sm="6"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-sm="7"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-sm="8"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-sm="9"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-sm="10"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-sm="11"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-sm="12"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 927px) {
  :host([cols-md="1"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-md="2"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-md="3"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-md="4"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-md="5"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-md="6"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-md="7"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-md="8"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-md="9"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-md="10"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-md="11"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-md="12"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 928px) {
  :host([cols-lg="1"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-lg="2"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-lg="3"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-lg="4"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-lg="5"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-lg="6"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-lg="7"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-lg="8"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-lg="9"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-lg="10"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-lg="11"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-lg="12"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 1183px) {
  :host([cols-xl="1"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xl="2"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xl="3"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xl="4"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xl="5"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xl="6"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xl="7"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xl="8"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xl="9"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xl="10"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xl="11"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xl="12"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 2463px) {
  :host([cols-xxl="1"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xxl="2"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xxl="3"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xxl="4"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xxl="5"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xxl="6"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xxl="7"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xxl="8"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xxl="9"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xxl="10"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xxl="11"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xxl="12"]) .ids-form-layout-group-content {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
:host([col-span="1"]) {
  grid-column: span 1;
}

:host([col-span="2"]) {
  grid-column: span 2;
}

:host([col-span="3"]) {
  grid-column: span 3;
}

:host([col-span="4"]) {
  grid-column: span 4;
}

:host([col-span="5"]) {
  grid-column: span 5;
}

:host([col-span="6"]) {
  grid-column: span 6;
}

:host([col-span="7"]) {
  grid-column: span 7;
}

:host([col-span="8"]) {
  grid-column: span 8;
}

:host([col-span="9"]) {
  grid-column: span 9;
}

:host([col-span="10"]) {
  grid-column: span 10;
}

:host([col-span="11"]) {
  grid-column: span 11;
}

:host([col-span="12"]) {
  grid-column: span 12;
}

@media (width >= 0) {
  :host([col-span-xs="1"]:not([enable-container])) {
    grid-column: span 1;
  }
  :host([col-span-xs="2"]:not([enable-container])) {
    grid-column: span 2;
  }
  :host([col-span-xs="3"]:not([enable-container])) {
    grid-column: span 3;
  }
  :host([col-span-xs="4"]:not([enable-container])) {
    grid-column: span 4;
  }
  :host([col-span-xs="5"]:not([enable-container])) {
    grid-column: span 5;
  }
  :host([col-span-xs="6"]:not([enable-container])) {
    grid-column: span 6;
  }
  :host([col-span-xs="7"]:not([enable-container])) {
    grid-column: span 7;
  }
  :host([col-span-xs="8"]:not([enable-container])) {
    grid-column: span 8;
  }
  :host([col-span-xs="9"]:not([enable-container])) {
    grid-column: span 9;
  }
  :host([col-span-xs="10"]:not([enable-container])) {
    grid-column: span 10;
  }
  :host([col-span-xs="11"]:not([enable-container])) {
    grid-column: span 11;
  }
  :host([col-span-xs="12"]:not([enable-container])) {
    grid-column: span 12;
  }
}
@media (width >= 767px) {
  :host([col-span-sm="1"]:not([enable-container])) {
    grid-column: span 1;
  }
  :host([col-span-sm="2"]:not([enable-container])) {
    grid-column: span 2;
  }
  :host([col-span-sm="3"]:not([enable-container])) {
    grid-column: span 3;
  }
  :host([col-span-sm="4"]:not([enable-container])) {
    grid-column: span 4;
  }
  :host([col-span-sm="5"]:not([enable-container])) {
    grid-column: span 5;
  }
  :host([col-span-sm="6"]:not([enable-container])) {
    grid-column: span 6;
  }
  :host([col-span-sm="7"]:not([enable-container])) {
    grid-column: span 7;
  }
  :host([col-span-sm="8"]:not([enable-container])) {
    grid-column: span 8;
  }
  :host([col-span-sm="9"]:not([enable-container])) {
    grid-column: span 9;
  }
  :host([col-span-sm="10"]:not([enable-container])) {
    grid-column: span 10;
  }
  :host([col-span-sm="11"]:not([enable-container])) {
    grid-column: span 11;
  }
  :host([col-span-sm="12"]:not([enable-container])) {
    grid-column: span 12;
  }
}
@media (width >= 927px) {
  :host([col-span-md="1"]:not([enable-container])) {
    grid-column: span 1;
  }
  :host([col-span-md="2"]:not([enable-container])) {
    grid-column: span 2;
  }
  :host([col-span-md="3"]:not([enable-container])) {
    grid-column: span 3;
  }
  :host([col-span-md="4"]:not([enable-container])) {
    grid-column: span 4;
  }
  :host([col-span-md="5"]:not([enable-container])) {
    grid-column: span 5;
  }
  :host([col-span-md="6"]:not([enable-container])) {
    grid-column: span 6;
  }
  :host([col-span-md="7"]:not([enable-container])) {
    grid-column: span 7;
  }
  :host([col-span-md="8"]:not([enable-container])) {
    grid-column: span 8;
  }
  :host([col-span-md="9"]:not([enable-container])) {
    grid-column: span 9;
  }
  :host([col-span-md="10"]:not([enable-container])) {
    grid-column: span 10;
  }
  :host([col-span-md="11"]:not([enable-container])) {
    grid-column: span 11;
  }
  :host([col-span-md="12"]:not([enable-container])) {
    grid-column: span 12;
  }
}
@media (width >= 928px) {
  :host([col-span-lg="1"]:not([enable-container])) {
    grid-column: span 1;
  }
  :host([col-span-lg="2"]:not([enable-container])) {
    grid-column: span 2;
  }
  :host([col-span-lg="3"]:not([enable-container])) {
    grid-column: span 3;
  }
  :host([col-span-lg="4"]:not([enable-container])) {
    grid-column: span 4;
  }
  :host([col-span-lg="5"]:not([enable-container])) {
    grid-column: span 5;
  }
  :host([col-span-lg="6"]:not([enable-container])) {
    grid-column: span 6;
  }
  :host([col-span-lg="7"]:not([enable-container])) {
    grid-column: span 7;
  }
  :host([col-span-lg="8"]:not([enable-container])) {
    grid-column: span 8;
  }
  :host([col-span-lg="9"]:not([enable-container])) {
    grid-column: span 9;
  }
  :host([col-span-lg="10"]:not([enable-container])) {
    grid-column: span 10;
  }
  :host([col-span-lg="11"]:not([enable-container])) {
    grid-column: span 11;
  }
  :host([col-span-lg="12"]:not([enable-container])) {
    grid-column: span 12;
  }
}
@media (width >= 1183px) {
  :host([col-span-xl="1"]:not([enable-container])) {
    grid-column: span 1;
  }
  :host([col-span-xl="2"]:not([enable-container])) {
    grid-column: span 2;
  }
  :host([col-span-xl="3"]:not([enable-container])) {
    grid-column: span 3;
  }
  :host([col-span-xl="4"]:not([enable-container])) {
    grid-column: span 4;
  }
  :host([col-span-xl="5"]:not([enable-container])) {
    grid-column: span 5;
  }
  :host([col-span-xl="6"]:not([enable-container])) {
    grid-column: span 6;
  }
  :host([col-span-xl="7"]:not([enable-container])) {
    grid-column: span 7;
  }
  :host([col-span-xl="8"]:not([enable-container])) {
    grid-column: span 8;
  }
  :host([col-span-xl="9"]:not([enable-container])) {
    grid-column: span 9;
  }
  :host([col-span-xl="10"]:not([enable-container])) {
    grid-column: span 10;
  }
  :host([col-span-xl="11"]:not([enable-container])) {
    grid-column: span 11;
  }
  :host([col-span-xl="12"]:not([enable-container])) {
    grid-column: span 12;
  }
}
@media (width >= 2463px) {
  :host([col-span-xxl="1"]:not([enable-container])) {
    grid-column: span 1;
  }
  :host([col-span-xxl="2"]:not([enable-container])) {
    grid-column: span 2;
  }
  :host([col-span-xxl="3"]:not([enable-container])) {
    grid-column: span 3;
  }
  :host([col-span-xxl="4"]:not([enable-container])) {
    grid-column: span 4;
  }
  :host([col-span-xxl="5"]:not([enable-container])) {
    grid-column: span 5;
  }
  :host([col-span-xxl="6"]:not([enable-container])) {
    grid-column: span 6;
  }
  :host([col-span-xxl="7"]:not([enable-container])) {
    grid-column: span 7;
  }
  :host([col-span-xxl="8"]:not([enable-container])) {
    grid-column: span 8;
  }
  :host([col-span-xxl="9"]:not([enable-container])) {
    grid-column: span 9;
  }
  :host([col-span-xxl="10"]:not([enable-container])) {
    grid-column: span 10;
  }
  :host([col-span-xxl="11"]:not([enable-container])) {
    grid-column: span 11;
  }
  :host([col-span-xxl="12"]:not([enable-container])) {
    grid-column: span 12;
  }
}
@container (width >= 0) {
  :host([col-span-xs="1"]) {
    grid-column: span 1;
  }
  :host([col-span-xs="2"]) {
    grid-column: span 2;
  }
  :host([col-span-xs="3"]) {
    grid-column: span 3;
  }
  :host([col-span-xs="4"]) {
    grid-column: span 4;
  }
  :host([col-span-xs="5"]) {
    grid-column: span 5;
  }
  :host([col-span-xs="6"]) {
    grid-column: span 6;
  }
  :host([col-span-xs="7"]) {
    grid-column: span 7;
  }
  :host([col-span-xs="8"]) {
    grid-column: span 8;
  }
  :host([col-span-xs="9"]) {
    grid-column: span 9;
  }
  :host([col-span-xs="10"]) {
    grid-column: span 10;
  }
  :host([col-span-xs="11"]) {
    grid-column: span 11;
  }
  :host([col-span-xs="12"]) {
    grid-column: span 12;
  }
}
@container (width >= 767px) {
  :host([col-span-sm="1"]) {
    grid-column: span 1;
  }
  :host([col-span-sm="2"]) {
    grid-column: span 2;
  }
  :host([col-span-sm="3"]) {
    grid-column: span 3;
  }
  :host([col-span-sm="4"]) {
    grid-column: span 4;
  }
  :host([col-span-sm="5"]) {
    grid-column: span 5;
  }
  :host([col-span-sm="6"]) {
    grid-column: span 6;
  }
  :host([col-span-sm="7"]) {
    grid-column: span 7;
  }
  :host([col-span-sm="8"]) {
    grid-column: span 8;
  }
  :host([col-span-sm="9"]) {
    grid-column: span 9;
  }
  :host([col-span-sm="10"]) {
    grid-column: span 10;
  }
  :host([col-span-sm="11"]) {
    grid-column: span 11;
  }
  :host([col-span-sm="12"]) {
    grid-column: span 12;
  }
}
@container (width >= 927px) {
  :host([col-span-md="1"]) {
    grid-column: span 1;
  }
  :host([col-span-md="2"]) {
    grid-column: span 2;
  }
  :host([col-span-md="3"]) {
    grid-column: span 3;
  }
  :host([col-span-md="4"]) {
    grid-column: span 4;
  }
  :host([col-span-md="5"]) {
    grid-column: span 5;
  }
  :host([col-span-md="6"]) {
    grid-column: span 6;
  }
  :host([col-span-md="7"]) {
    grid-column: span 7;
  }
  :host([col-span-md="8"]) {
    grid-column: span 8;
  }
  :host([col-span-md="9"]) {
    grid-column: span 9;
  }
  :host([col-span-md="10"]) {
    grid-column: span 10;
  }
  :host([col-span-md="11"]) {
    grid-column: span 11;
  }
  :host([col-span-md="12"]) {
    grid-column: span 12;
  }
}
@container (width >= 928px) {
  :host([col-span-lg="1"]) {
    grid-column: span 1;
  }
  :host([col-span-lg="2"]) {
    grid-column: span 2;
  }
  :host([col-span-lg="3"]) {
    grid-column: span 3;
  }
  :host([col-span-lg="4"]) {
    grid-column: span 4;
  }
  :host([col-span-lg="5"]) {
    grid-column: span 5;
  }
  :host([col-span-lg="6"]) {
    grid-column: span 6;
  }
  :host([col-span-lg="7"]) {
    grid-column: span 7;
  }
  :host([col-span-lg="8"]) {
    grid-column: span 8;
  }
  :host([col-span-lg="9"]) {
    grid-column: span 9;
  }
  :host([col-span-lg="10"]) {
    grid-column: span 10;
  }
  :host([col-span-lg="11"]) {
    grid-column: span 11;
  }
  :host([col-span-lg="12"]) {
    grid-column: span 12;
  }
}
@container (width >= 1183px) {
  :host([col-span-xl="1"]) {
    grid-column: span 1;
  }
  :host([col-span-xl="2"]) {
    grid-column: span 2;
  }
  :host([col-span-xl="3"]) {
    grid-column: span 3;
  }
  :host([col-span-xl="4"]) {
    grid-column: span 4;
  }
  :host([col-span-xl="5"]) {
    grid-column: span 5;
  }
  :host([col-span-xl="6"]) {
    grid-column: span 6;
  }
  :host([col-span-xl="7"]) {
    grid-column: span 7;
  }
  :host([col-span-xl="8"]) {
    grid-column: span 8;
  }
  :host([col-span-xl="9"]) {
    grid-column: span 9;
  }
  :host([col-span-xl="10"]) {
    grid-column: span 10;
  }
  :host([col-span-xl="11"]) {
    grid-column: span 11;
  }
  :host([col-span-xl="12"]) {
    grid-column: span 12;
  }
}
@container (width >= 2463px) {
  :host([col-span-xxl="1"]) {
    grid-column: span 1;
  }
  :host([col-span-xxl="2"]) {
    grid-column: span 2;
  }
  :host([col-span-xxl="3"]) {
    grid-column: span 3;
  }
  :host([col-span-xxl="4"]) {
    grid-column: span 4;
  }
  :host([col-span-xxl="5"]) {
    grid-column: span 5;
  }
  :host([col-span-xxl="6"]) {
    grid-column: span 6;
  }
  :host([col-span-xxl="7"]) {
    grid-column: span 7;
  }
  :host([col-span-xxl="8"]) {
    grid-column: span 8;
  }
  :host([col-span-xxl="9"]) {
    grid-column: span 9;
  }
  :host([col-span-xxl="10"]) {
    grid-column: span 10;
  }
  :host([col-span-xxl="11"]) {
    grid-column: span 11;
  }
  :host([col-span-xxl="12"]) {
    grid-column: span 12;
  }
}
:host([gap=none]),
.ids-form-layout-group-gap-none {
  gap: 0;
}

:host([gap="2xs"]),
.ids-form-layout-group-gap-2xs {
  gap: var(--ids-space-2xs);
}

:host([gap=xs]),
.ids-form-layout-group-gap-xs {
  gap: var(--ids-space-xs);
}

:host([gap=sm]),
.ids-form-layout-group-gap-sm {
  gap: var(--ids-space-sm);
}

:host([gap=md]),
.ids-form-layout-group-gap-md {
  gap: var(--ids-space-md);
}

:host([gap=lg]),
.ids-form-layout-group-gap-lg {
  gap: var(--ids-space-lg);
}

:host([gap=xl]),
.ids-form-layout-group-gap-xl {
  gap: var(--ids-space-xl);
}

.ids-form-layout-group-heading {
  display: block;
  grid-column: 1/-1;
  margin-block-end: var(--ids-space-sm);
  color: var(--ids-input-label-color-text-default);
  border-bottom: 1px solid var(--ids-color-border-weaker);
  padding: var(--ids-space-xs);
}

::slotted([label-state=collapsed]) .ids-label-text {
  display: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
